import { render, staticRenderFns } from "./StartLotRegistration.vue?vue&type=template&id=5c809ebc&"
import script from "./StartLotRegistration.vue?vue&type=script&lang=js&"
export * from "./StartLotRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports